import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { find, propEq, path } from 'ramda';
import he from 'he';
import PropTypes from 'prop-types';

import { createMarkup, getRegistrationExpirationInfo } from '../../../../util/helpers';
import { isNilOrEmpty } from '../../../../util/redux';
import { routes } from '../../../index';

import Card from '../../../../components/Card/index';
import magic from '../../../../util/magic';

const mapStore = (store) => ({
  certifications: store.certifications.filter((c) => c.deletedAt == null),
  trainings: store.trainings,
  user: store.user,
});

const propTypes = {
  certifications: PropTypes.array,
  trainings: PropTypes.array,
  user: PropTypes.object,
};

class RegistrationTypes extends Component {
  state = {};

  renderStaticCards = () => {
    return (
      <div className="row">
        <div className="col">
          <Card>
            <Card.Header compact registration>
              Course Registration
            </Card.Header>
            <Card.Body>
              Are you passionate about helping people with their money? Select the course that best meets your unique
              needs and goals.
            </Card.Body>
          </Card>
        </div>
      </div>
    );
  };

  renderCard = (card, training) => {
    const { user } = this.props;
    const certificationId = training ? card.certificationId : card.id;
    const registration = find(propEq('certificationId', certificationId), user.latestRegistrations);
    getRegistrationExpirationInfo(registration, user.extensions);

    let buttonText = 'Register';
    if (path(['expirationStatus'], registration) == magic.expiredWithoutExtension) buttonText = 'Request Extension';
    else if (path(['expirationStatus'], registration) == magic.notExpired) buttonText = 'Continue Registration';

    return (
      <Card key={card.id} registration={!training} training={training} className="mb-4">
        <Card.Header divider>
          {training ? 'TRAINING' : 'CERTIFICATION'}
          {card.type ? ' | ' + card.type : ''}
        </Card.Header>
        <Card.Body>
          <h1>{he.decode(card.name)}</h1>
          <h4
            className={training ? 'yellow-heading' : 'blue-heading'}
            dangerouslySetInnerHTML={createMarkup(card.fullName)}
          />
          <p dangerouslySetInnerHTML={createMarkup(card.description)} />
        </Card.Body>
        {/* TODO: Make this not hardcoded */}
        {(!training || card.available) && !isNilOrEmpty(certificationId) ? (
          <Card.Action
            as={Link}
            to={
              path(['expirationStatus'], registration) == magic.expiredWithoutExtension
                ? routes.certificationsAndTraining.extension.request
                : routes.certificationsAndTraining.register.typeBuilder(certificationId)
            }
          >
            {buttonText}
          </Card.Action>
        ) : (!training || card.available) && isNilOrEmpty(certificationId) ? (
          <Card.Action
            as={Link}
            to={
              path(['expirationStatus'], registration) == magic.expiredWithoutExtension
                ? routes.certificationsAndTraining.extension.request
                : routes.certificationsAndTraining.register.trainingBuilder(card.categoryId)
            }
          >
            {buttonText}
          </Card.Action>
        ) : (
          <Card.Action disabled>Coming Soon</Card.Action>
        )}
      </Card>
    );
  };

  render() {
    const {} = this.state;
    const { certifications, trainings } = this.props;

    return (
      <div>
        {this.renderStaticCards()}
        <div className="row mt-4">
          <div className="col">
            <div className="card-deck">
              {certifications.map((certification) => this.renderCard(certification, false))}
              {trainings.map((training) => this.renderCard(training, true))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

RegistrationTypes.propTypes = propTypes;

export default connect(mapStore)(RegistrationTypes);
